<template>
    <div class="w-full">
        <a :href="props.advert.RedirectUrl" target="_blank" class="mx-auto block max-w-full">
            <template v-if="advert.SmallBannerHtml && advert.LargeBannerHtml">
                <div class="hidden md:block mx-auto max-w-full select-none" v-html="advert.LargeBannerHtml"></div>
                <div class="block md:hidden mx-auto max-w-full select-none" v-html="advert.SmallBannerHtml"></div>
            </template>
            <template v-else-if="advert.LargeBannerUrl && advert.SmallBannerUrl">
                <img :src="advert.LargeBannerUrl" :alt="advert.ImageAlt" class="hidden md:block mx-auto max-w-full">
                <img :src="advert.SmallBannerUrl" :alt="advert.ImageAlt" class="block md:hidden mx-auto max-w-full">
            </template>
        </a>
    </div>
</template>
<script setup>
    import Http from '@/js/global/http'
    import { route } from 'ziggy'

    const props = defineProps({
        advert: {
            type: Object,
            default: window.advert?.data ?? null
        }
    })

    if (window.advert.adStatistics.reported == false && props.advert.UId) {
        Http.post(route('ad-statistics'), {
            data: {
                UId: props.advert.UId,
                location: props.advert.Location
            },
            success: () => {
                window.advert.adStatistics.reported = true
            }
        })
    }

</script>
